import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PatientChartComponent} from './patient-chart.component';
import {LayoutModule} from '../layout/layout.module';
import {routing} from './patient-chart.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {NgxPaginationModule} from 'ngx-pagination';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';
import {DataService} from './data.service';
import {OpdPatientConfigService} from '../configuration/application-configuration/opd-patient-config/opd-patient-config.service';

@NgModule({
  imports: [
    CommonModule, LayoutModule, routing, FormsModule, ReactiveFormsModule
    , HttpModule, NgxPaginationModule, SharedTranslationModule
  ],
  declarations: [PatientChartComponent],
  providers: [MstVisitService, DataService, OpdPatientConfigService]
})
export class PatientChartModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart.module.ts